// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2lNWe","title":"_1Q8ta","back-btn":"_1oPYN","loading":"_XPIe","spin":"_15ZAS","share-wrapper":"rClI7"};